import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from 'common/store/genesys-cloud/common/action-namespace';
import { Configuration } from '../models/configuration.model';

const withNameSpace = withGenesysCloudStoreNameSpace('Configurations');

export const loadConfigurations = createAction(withNameSpace('Load configurations'), props<{ deploymentId?: string }>());

export const configurationChanged = createAction(
  withNameSpace('Configuration changed'),
  props<{ configuration: Configuration }>()
);
